import { cB as i, cM as t, c as a } from "../../../_utils/cssr/index.js";
const e = i("form", [t("inline", `
 width: 100%;
 display: inline-flex;
 align-items: flex-start;
 align-content: space-around;
 `, [i("form-item", {
  width: "auto",
  marginRight: "18px"
}, [a("&:last-child", {
  marginRight: 0
})])])]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/src/styles/form.cssr.js
// module id = 1691
// module chunks = 67